import { useQuery } from "@tanstack/react-query";
import { ApiError } from "src/types/interfaces/api-error";
import { SiteSecurity } from "src/types/responses/site";
import { securityAdminsSitesApi } from "../../api/lib/security-admins-sites";
import { securityAdminsSitesKeys } from "../../api/query-keys/security-admins-sites";

export const useAvailableSecurityAdminsSites = (enabled?: boolean, retry?: boolean) => {
  return useQuery<SiteSecurity[], ApiError>({
    queryKey: securityAdminsSitesKeys.lists(),
    queryFn: securityAdminsSitesApi.fetchAvailableSecurityAdminsSites,
    retry,
    enabled: enabled ?? true,
  });
};
